import createIcon from '../../createIcon';

/**
 * @component @name PlayArrow
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi41IDVWMTlMMTcuNSAxMkw2LjUgNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PlayArrow = createIcon('PlayArrow', [
  ['path', { d: 'M6.5 5V19L17.5 12L6.5 5Z', key: '1wq9q6' }],
]);

export default PlayArrow;
